import { DeviceModel } from '@shure/shared/angular/data-access/system-api/models';

import { DefaultCdmDeviceBehaviorPlugin } from './default-cdm.device-behavior';

export class AdtqCdmDeviceBehaviorPlugin extends DefaultCdmDeviceBehaviorPlugin {
	public override readonly models: DeviceModel[] = [DeviceModel.ADTQ];

	public hideIdentifyAllButton(): boolean {
		return true;
	}

	public hideIpConfiguration(): boolean {
		return true;
	}
}
